module.exports = __webpack_public_path__ + "img/Péter Szilágyi.8e449122.jpg";